import { createContext } from 'react';

const HandleRefreshContext = createContext();
export default HandleRefreshContext;
